<button type="submit" [disabled]="isDisabled()" class="{{ bgColor() }} text-white 
           {{ isDisabled() ? '' : 'shadow hover:shadow-lg' }} 
           font-bold focus:outline-none text-sm  disabled:text-gray-400 titlecase rounded-lg
           min-h-[40px]  /* Ensure a consistent height */
           {{ fullWidth() ? 'w-full py-2' : padding() }}">
    <div class="flex flex-row flex-nowrap items-center {{ fullWidth() ? 'justify-center' : '' }}">

        @if (isLoading()) {
        <svg class="animate-spin shrink-0 -ml-1 mr-2 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none"
            viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
            </path>
        </svg>
        } @else {
        @if(icon() != null && icon() !== '') {
        <i class="{{ icon() }} mr-2 leading-relaxed"></i>
        }
        }

        <span class="whitespace-nowrap">{{ actionText() }}</span>

        @if (suffixIcon() !== '') {
        <i class="{{ suffixIcon() }} ml-2 leading-relaxed"></i>
        }
    </div>
</button>